"use client"

import Link from "next/link"
import Image from "next/image"
import { useState } from "react"
import { Menu, X } from "lucide-react"

const navLinks = [
  { href: "#services", label: "خدماتنا" },
  { href: "#properties", label: "عقاراتنا" },
  { href: "/units", label: "الوحدات المتاحة" },
  { href: "#contact", label: "تواصل معنا" },
]

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <header className="fixed top-0 left-0 right-0 z-40 p-4">
      <nav className="max-w-5xl mx-auto flex items-center justify-between h-14 px-6 rounded-full bg-zinc-900/70 border border-zinc-800/50 backdrop-blur-md">
        <Link href="/" className="flex items-center gap-3">
          <div className="relative w-9 h-9 rounded-xl overflow-hidden flex-shrink-0">
            <Image src="/logo.jpeg" alt="بنايه للعقارات" fill className="object-cover" />
          </div>
          <span className="font-display text-xl font-bold text-zinc-100">
            بنايه <span className="text-zinc-400 text-sm font-normal">للعقارات</span>
          </span>
        </Link>
        
        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="px-4 py-1.5 text-sm rounded-full transition-colors text-zinc-400 hover:text-zinc-100"
            >
              {link.label}
            </Link>
          ))}
          <Link
            href="https://www.facebook.com/share/17zCE5mVKx/?mibextid=wwXIfr"
            target="_blank"
            className="p-2 rounded-full text-zinc-400 hover:text-blue-400 transition-colors"
            aria-label="Facebook"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
          </Link>
          <Link
            href="https://wa.me/201212129070"
            target="_blank"
            className="me-2 px-4 py-1.5 text-sm rounded-full bg-brand text-white font-medium hover:bg-brand-dark transition-colors"
          >
            تواصل معنا
          </Link>
        </div>

        <button
          className="md:hidden text-zinc-100 p-2"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {isOpen && (
        <div className="md:hidden mt-2 mx-4 p-4 rounded-2xl bg-zinc-900/95 border border-zinc-800/50 backdrop-blur-md">
          <div className="flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="px-4 py-3 text-sm rounded-xl transition-colors text-zinc-400 hover:text-zinc-100 hover:bg-zinc-800/50"
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link
              href="https://www.facebook.com/share/17zCE5mVKx/?mibextid=wwXIfr"
              target="_blank"
              className="px-4 py-3 text-sm rounded-xl text-zinc-400 hover:text-blue-400 flex items-center gap-2"
              onClick={() => setIsOpen(false)}
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              فيسبوك
            </Link>
            <Link
              href="https://wa.me/201212129070"
              target="_blank"
              className="mt-2 px-4 py-3 text-sm text-center rounded-xl bg-brand text-white font-medium hover:bg-brand-dark transition-colors"
              onClick={() => setIsOpen(false)}
            >
              تواصل عبر واتساب
            </Link>
          </div>
        </div>
      )}
    </header>
  )
}
